import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import "datatables.net-dt";
import $ from "jquery";
import { baseURL } from "../../axios/common";

const ListSports = () => {
  const [sports, setSports] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchSports();
  }, []);

  useEffect(() => {
    if (sports.length) {
      if (!$.fn.DataTable.isDataTable("#SportsTable")) {
        $("#SportsTable").DataTable();
      }
    }
  }, [sports]);

  // Fetch Sports List
  const fetchSports = async () => {
    try {
      const response = await axios.get(baseURL + "sports/list", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setSports(response.data.data);
    } catch (error) {
      console.error("Error fetching sports:", error);
    }
  };

  // Open delete confirmation popup
  const confirmDelete = (sport) => {
    setSelectedSport(sport);
    setShowPopup(true);
  };

  // Cancel delete
  const cancelDelete = () => {
    setShowPopup(false);
    setSelectedSport(null);
  };

  // Handle delete: Call both APIs
  const deleteSport = async () => {
    if (!selectedSport) return;

    try {
      // Delete the file first
      await axios.post(
        `${baseURL}global/deleteFile`,
        {
          file_path: selectedSport.icon_path,
          language: "en",
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Delete the sport entry
      await axios.delete(`${baseURL}sports/delete/${selectedSport.id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      // Remove from state after successful deletion
      setSports(sports.filter((sport) => sport.id !== selectedSport.id));

      // Close the popup
      setShowPopup(false);
      setSelectedSport(null);
    } catch (error) {
      console.error("Error deleting sport:", error);
      alert("Failed to delete sport.");
    }
  };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Sports</h2>
                     <div className="add_btn">
                      <Link to="/suggestion-sport" className="btn btn-primary ms-auto d-blick">
                        Suggestions
                      </Link>
                      <Link to="/create-sport" className="btn btn-primary ms-auto d-blick">
                        Add Sport
                      </Link>
                      </div>

                    </div>
                    <div className="card-body">
                      <table id="SportsTable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th className="img-td">Icon</th>
                            <th>Sport Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sports.map((sport, index) => (
                            <tr key={sport.id}>
                              <td>{index + 1}</td>
                              <td className="img-td" style={{ textAlign: "center", verticalAlign: "middle" }}>
                                <div
                                  className="sport-icon"
                                  style={{
                                    backgroundColor: sport.color_code,
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src={baseURL + sport.icon_path}
                                    alt={sport.name}
                                    style={{ width: "60%", height: "60%" }}
                                  />
                                </div>
                              </td>
                              <td>{sport.name}</td>
                              <td className="table_action text-center">
                                <div className="active_td">
                                <Link to={`edit-sport/${sport.id}`}>
                                      <i className="fa fa-edit" />
                                  </Link>
                                  <button
                                    onClick={() => confirmDelete(sport)}
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <i className="fa fa-trash" style={{ color: "#f00" }} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Delete Confirmation Popup */}
      {showPopup && selectedSport && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ background: "#fff", padding: "20px", borderRadius: "5px", textAlign: "center" }}>
            <h3>Are you sure?</h3>
            <p>Do you really want to delete {selectedSport.name}?</p>
            <div style={{ marginTop: "20px" }}>
              <button
                onClick={deleteSport}
                style={{ background: "#f00", color: "#fff", padding: "10px", border: "none", borderRadius: "5px", marginRight: "10px", cursor: "pointer" }}
              >
                Yes, Delete
              </button>
              <button
                onClick={cancelDelete}
                style={{ background: "#ccc", padding: "10px", border: "none", borderRadius: "5px", cursor: "pointer" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListSports;
